<template>
  <div>
    <Skeleton v-if="isLoading" height="400px" />
    <button v-if="!isError && !isLoading" id="print-label-cta-top" class="primary button expanded hide-for-print" @click="showPrintLabel()">
      PRINT RETURN LABEL
    </button>
    <Notification v-if="isError && !isShippingDetailsError" severity="error" class="margin-top-xs" :closable="false">
      {{ isError }}
    </Notification>
    <Notification
      v-if="enhancedReturnDetails.isRmaReturn && !isShippingDetailsLoading && isShippingDetailsError"
      severity="error"
      class="margin-top-xs"
      :closable="false"
    >
      {{ config.RMA_DEEPLINK_LABEL_ERROR }}
    </Notification>
    <PrintReturnLabel
      v-if="!isLoading && enhancedReturnDetails"
      class="margin-top-xs"
      :page="substituteType ? 'return-details' : ''"
      :ssre-type="substituteType"
      :return-details="enhancedReturnDetails"
      @print="showPrintLabel"
    />
    <button
      v-if="!isError && !isLoading"
      id="print-label-cta-bottom"
      class="primary button expanded margin-top-m hide-for-print"
      @click="showPrintLabel()"
    >
      PRINT RETURN LABEL
    </button>
  </div>
</template>
<script setup>
import { onBeforeMount, onUnmounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import Notification from '@nuxt-common/atomic-ui/app/components/notification/Notification.vue';
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton.vue';

import { useReturnDetailStore } from '@/stores/returns/useReturnDetailStore';
import { useReturnItemStore } from '@/stores/returns/useReturnItemStore';

import PrintReturnLabel from '@/components/returns/PrintReturnLabel.vue';

import * as config from 'config';

const returnDetailStore = useReturnDetailStore();
const returnItemsStore = useReturnItemStore();

const route = useRoute();
const router = useRouter();
// computed
const isError = computed(() => returnDetailStore.error);

const isLoading = computed(() => {
  const hasReturnDetails = Object.keys(returnDetailStore.returnDetails).length > 0;

  if (!hasReturnDetails) {
    return returnDetailStore.isLoading;
  }

  if (hasReturnDetails && returnDetailStore.returnDetails.isRmaReturn) {
    return returnItemsStore.loading.getShippingDetails;
  }

  if (returnDetailStore.returnDetails.returnStatusCode !== 300) return true;

  if (isError.value) {
    return false;
  }

  return returnDetailStore.isLoading;
});

const substituteType = computed(() => returnDetailStore.substituteType);
const shippingDetails = computed(() => returnItemsStore.shippingDetails);
const isShippingDetailsLoading = computed(() => returnItemsStore.loading.getShippingDetails);
const isShippingDetailsError = computed(() => returnItemsStore.errors.getShippingDetails);

onBeforeMount(async () => {
  const { token, rdv } = route.query;
  await returnDetailStore.GET_RETURN_DETAILS({ token, rdv });
  const returnDetails = returnDetailStore.returnDetails;
  if (returnDetails?.returnStatusCode && returnDetails.returnStatusCode !== 300) {
    await router.push({ name: 'Return Details', query: { pid: returnDetails.pidToken, orderNumber: returnDetails.orderNumber } });
    return;
  }
  if (returnDetails.pidToken) {
    await returnItemsStore.GET_SHIPPING_DETAILS({ pidToken: returnDetails.pidToken });
  } else if (returnDetails.isRmaReturn) {
    await returnItemsStore.GET_SHIPPING_DETAILS_BY_RMA_ID({
      rmaId: returnDetails.pendingReturnId,
    });
  }
});

const enhancedReturnDetails = computed(() => {
  const shippingLabels = shippingDetails.value.shippingLabels ?? [];
  const shippingLabel = shippingLabels[0] ?? {};
  const returnDetails = returnDetailStore.returnDetails;
  return {
    ...returnDetails,
    ...(returnDetails.pidToken || returnDetails.isRmaReturn
      ? {
          labelImageUrl: shippingLabel?.base64Label,
          rmaId: returnDetails.pendingReturnId,
        }
      : {}),
  };
});

const showPrintLabel = () => {
  if (!isLoading.value && !isError.value && !isShippingDetailsError.value && !isShippingDetailsLoading.value) window.print();
};
onUnmounted(() => {
  if (returnDetailStore.returnDetails.returnStatusCode === 300) {
    returnDetailStore.CLEAR_RETURN_DETAILS();
  }
});
</script>

<style lang="scss">
@media print {
  #nav-header-wrapper,
  #nav-header,
  #nav-footer {
    display: none;
  }

  section .banner-content {
    display: none !important;
  }
}
</style>
